<!-- Gradent.vue -->
<template>
  <div>
    <!-- 上半部分的UI，不变 -->
    <div class="product-list-box" style="width: 70%; margin: 0 auto">
      <div class="product-list-item">
        <div id="maize" class="cursor" @click="changeType('maize')">
          <img src="../../assets/picture/yumiICON.png" alt="Icon" />
          <h5>Maize</h5>
        </div>
      </div>
      <div class="product-list-item">
        <div id="rice" class="cursor" @click="changeType('rice')">
          <img
            src="../../assets/picture/southeast-removebg-preview.png"
            alt="Icon"
          />
          <h5>Rice</h5>
        </div>
      </div>
      <div class="product-list-item">
        <div id="cotton" class="cursor" @click="changeType('cotton')">
          <img src="../../assets/picture/mianhuaICON.png" alt="Icon" />
          <h5>Cotton</h5>
        </div>
      </div>
      <div class="product-list-item">
        <div id="wheat" class="cursor" @click="changeType('wheat')">
          <img src="../../assets/picture/xiaomaiICON.png" alt="Icon" />
          <h5>Wheat</h5>
        </div>
      </div>
    </div>
    <!-- 动态加载的组件部分 -->
    <picCompoents :message="message"></picCompoents>
  </div>
</template>

<script>
import picCompoents from './picCompoents.vue';

export default {
  name: "Motifs",
  data() {
    return {
      // 动态组件
      message: "maize"
    };
  },
  components: {
    picCompoents
  },
  created() {
    
  },
  methods: {
    changeType(componentName) {
      this.message = componentName
    },
  },
};
</script>

<style scoped src="../../assets/css/style.css"></style>

<style scoped>
.product-list-box {
  max-width: 900px;
}
</style>
